import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MessageService } from './message.service';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  apiUrl = environment.apiUrl;

  //token  = sessionStorage.getItem('token')?.toString().replace(/['"]+/g, '') || '';

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
  ) {}

  /*  setToken(token: string) {
    this.token = token.toString().replace(/['"]+/g, '');
  } */

  /*  getHeaders() {
    return { headers: new HttpHeaders().set('Authorization', `Bearer ${this.token}`) };
  }
 */
  postData(url: string, body: any): Observable<any> {
    //return this.http.post<any>(`${this.apiUrl}/${url}`, body, this.getHeaders())
    return this.http.post<any>(`${this.apiUrl}/${url}`, body).pipe(
      tap((x) => this.log('Registro creado', 'success')),
      catchError(this.handleError<any>('postData')),
    );
  }

  getData(url: string): Observable<any> {
    //return this.http.get<any>(`${this.apiUrl}/${url}`, this.getHeaders())
    return this.http.get<any>(`${this.apiUrl}/${url}`).pipe(
      tap((x) => this.log('Leyendo', 'info')),
      catchError(this.handleError<any>('getData')),
    );
  }

  getDataTwo(
    url: string,
    searchQuery: string,
    type: string,
    page: number,
    limit: number,
  ): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('search', searchQuery)
      .set('type', type);

    return this.http.get(`${this.apiUrl}/${url}`, { params }).pipe(
      tap((x) => this.log('Leyendo', 'success')),
      catchError(this.handleError<any>('getData')),
    );
  }

  putData(url: string, body: any): Observable<any> {
    //return this.http.put<any>(`${this.apiUrl}/${url}`, body, this.getHeaders())
    return this.http.put<any>(`${this.apiUrl}/${url}`, body).pipe(
      tap((x) => this.log('Registro actualizado', 'success')),
      catchError(this.handleError<any>('putData')),
    );
  }

  deleteData(url: string): Observable<any> {
    //return this.http.delete<any>(`${this.apiUrl}/${url}`, this.getHeaders())
    return this.http.delete<any>(`${this.apiUrl}/${url}`).pipe(
      tap((x) => this.log('Registro eliminado', 'success')),
      catchError(this.handleError<any>('deleteData')),
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error('en error', error); // log to console instead

      //const msg = error?.error?.msg || error.message || 'Unknown error';
      const msg =
        error?.error?.data.errors[0].msg || error.msg || 'Unknown error';

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`, 'danger');
      this.log(`${msg}`, 'danger');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private log(message: string, type: string) {
    //this.messageService.add(message, type);
  }

  isTokenExpired(token: string): boolean {
    try {
      const decoded: any = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp < currentTime;
    } catch (error) {
      return true; // Si no se puede decodificar, lo tratamos como expirado
    }
  }
}
